import { I18nShape } from '@tribeplatform/react-components/i18n'

export enum NavbarStyle {
  DEFAULT = 'default',
  STACKED = 'stacked',
}

export const availableNavbarStylesFactory = ({ $t }: I18nShape) => [
  {
    title: $t({
      defaultMessage: 'Default',
      id: 'Generics.Default',
    }),
    value: NavbarStyle.DEFAULT,
  },
  {
    title: $t({
      defaultMessage: 'Stacked',
      id: 'Navbar.Styles.Stacked',
    }),
    value: NavbarStyle.STACKED,
  },
]

export enum NavbarNavigationAction {
  OPEN_LINK = 'OPEN_LINK',
}

export type NavbarNavigationItem = {
  label: string
  action: NavbarNavigationAction
  link?: string
  openInNewWindow?: boolean
}

export enum NavbarControlType {
  BUTTON = 'BUTTON',
  ICON = 'ICON',
  AVATAR = 'AVATAR',
}

export enum NavbarControlAction {
  CREATE_ITEM = 'CREATE_ITEM',
  SHOW_NOTIFICATION = 'SHOW_NOTIFICATION',
  SHOW_MESSAGING = 'SHOW_MESSAGING',
  SHOW_PROFILE = 'SHOW_PROFILE',
  SIGNUP = 'SIGNUP',
  LOGIN = 'LOGIN',
}

export type NavbarControlItem = {
  type: NavbarControlType
  action: NavbarControlAction
  label: string
  icon?: string
  showLabel?: boolean
}

export const defaultNavbarControlItemsFactory: (
  intl: I18nShape,
) => NavbarControlItem[] = ({ $t }) => [
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.SHOW_MESSAGING,
    label: $t({
      defaultMessage: 'Show Messaging',
      id: 'Navbar.Controls.ShowMessaging',
    }),
    icon: 'chat',
    showLabel: null,
  },
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.SHOW_NOTIFICATION,
    label: $t({
      defaultMessage: 'Show Notification',
      id: 'Navbar.Controls.ShowNotification',
    }),
    icon: 'bell',
    showLabel: null,
  },
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.CREATE_ITEM,
    label: $t({
      defaultMessage: 'Create Post',
      id: 'Navbar.Controls.CreatePost',
    }),
    icon: 'plus',
    showLabel: false,
  },
  {
    type: NavbarControlType.AVATAR,
    action: NavbarControlAction.SHOW_PROFILE,
    label: $t({
      defaultMessage: 'Show Profile',
      id: 'Navbar.Controls.ShowProfile',
    }),
    icon: null,
    showLabel: null,
  },
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.LOGIN,
    label: $t({
      defaultMessage: 'Log in',
      id: 'Generics.LogIn',
    }),
    icon: null,
    showLabel: true,
  },
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.SIGNUP,
    label: $t({
      defaultMessage: 'Sign up',
      id: 'Generics.SignUp.Verb',
    }),
    icon: null,
    showLabel: true,
  },
]

export const defaultBottomBarControlItemsFactory: (
  intl: I18nShape,
) => NavbarControlItem[] = ({ $t }) => [
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.CREATE_ITEM,
    label: $t({
      defaultMessage: 'Create Post',
      id: 'Navbar.Controls.CreatePost',
    }),
    icon: 'plus',
    showLabel: false,
  },
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.SHOW_NOTIFICATION,
    label: $t({
      defaultMessage: 'Show Notification',
      id: 'Navbar.Controls.ShowNotification',
    }),
    icon: 'bell',
    showLabel: null,
  },
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.SHOW_MESSAGING,
    label: $t({
      defaultMessage: 'Show Messaging',
      id: 'Navbar.Controls.ShowMessaging',
    }),
    icon: 'chat',
    showLabel: null,
  },
]
